<ng-container #gridsterContent>
  <div
    id="gridster-container"
    *ngIf="dashboardReady && dashboard?.settings?.length; else emptyState"
    class="gridster-container"
    [style.height.px]="'100%'"
  >
    <grid
      class="grid"
      *ngIf="dashboard"
      [model]="dashboard"
      (onChange)="widgetsChanged($event)"
      (onResize)="widgetsResized($event)"
      (focusWidgetChanged)="focusWidgetChanged($event)"
    ></grid>
  </div>
</ng-container>

<ng-template #emptyState>
  <ng-container *ngIf="ownerOrAdmin; else emptyStateMember">
    <div class="empty-state">
      <span class="title">This homepage tab doesn't have any content yet</span>
      <span class="subtitle">Get Started by adding <ng-container *featureFlagEnabled="DISABLED_COLLECTIONS_WORKSPACE_FEATURE_FLAG">collections,  </ng-container>carousel and posts</span>
      <div class="cards-container">
        <ng-container *ngFor="let item of emptyStateItems">
          <ng-container *featureFlagEnabled="item.disabledWorkspaceFlag">
            <div  class="card-set" (click)="addItemToTab(item.id)">
              <u-icon [model]="{ type: 'font', value: item.icon }" [styles]="{ fontSize: '16px' }"></u-icon>
              <div class="card-set-title">{{ item.title }}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-template #emptyStateMember>
    <div class="empty-state">
      <u-icon
        [model]="{
          type: 'img',
          value: { lightUrl: 'assets/empty-state/no-widgets/sad-cat-light.svg', darkUrl: 'assets/empty-state/no-widgets/sad-cat-dark.svg' },
        }"
      ></u-icon>
      <span class="member-title"
        >This homepage tab is feeling a little<br />
        empty at the moment</span
      >
    </div>
  </ng-template>
</ng-template>
